export default {
  'pages.applicationCenter.card.free': '免費',
  'pages.applicationCenter.card.paid': '付費',
  'pages.applicationCenter.card.perSeat': '按席位計費',
  'pages.applicationCenter.card.pricePending': '價格待確認',
  'pages.applicationCenter.card.developerUnknown': '未提供開發者資訊',
  'pages.applicationCenter.card.noDescription':
    '尚無應用簡介，請查看詳情以瞭解更多。',
  'pages.applicationCenter.card.official': '官方認證',
  'pages.applicationCenter.card.installed': '已開通',
};
